"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#356EE9",
  fillRule: "evenodd",
  d: "M6.421 15.917c-.29.67-1.071.98-1.744.69a1.322 1.322 0 0 1-.693-1.74c.29-.67 2.295-1.958 2.295-1.958s.434 2.336.142 3.008Zm4.112 0c-.29.67-1.071.98-1.743.69a1.322 1.322 0 0 1-.694-1.74c.291-.67 2.294-1.958 2.294-1.958s.435 2.336.143 3.008Zm4.113 0a1.33 1.33 0 0 1-1.745.69 1.321 1.321 0 0 1-.693-1.74c.29-.67 2.295-1.958 2.295-1.958s.433 2.336.143 3.008Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A8ACBD",
  fillRule: "evenodd",
  d: "M5.948 12.034C4.32 12.034 3 10.652 3 8.947c0-1.705 1.32-3.088 2.948-3.088.264 0 .518.04.761.108.496-1.536 1.87-2.646 3.497-2.68l.037-.001.038-.002c1.926 0 3.514 1.514 3.742 3.467a2.44 2.44 0 0 1 .435-.042C15.862 6.71 17 7.901 17 9.372c0 1.47-1.138 2.662-2.542 2.662h-8.51Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=RainIcon20.js.map